import { c as _c } from "react/compiler-runtime";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import type { CreateWaveOutcomeConfig } from "@/types/waves.types";
import CreateWaveOutcomesRowCICApprove from "./CreateWaveOutcomesRowCICApprove";
import CreateWaveOutcomesRowCICRank from "./CreateWaveOutcomesRowCICRank";
import type { JSX } from "react";
export default function CreateWaveOutcomesRowCIC(t0) {
  const $ = _c(8);
  const {
    waveType,
    outcome
  } = t0;
  let t1;
  if ($[0] !== outcome) {
    t1 = <CreateWaveOutcomesRowCICApprove outcome={outcome} />;
    $[0] = outcome;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== outcome) {
    t2 = <CreateWaveOutcomesRowCICRank outcome={outcome} />;
    $[2] = outcome;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2) {
    t4 = {
      [ApiWaveType.Approve]: t1,
      [ApiWaveType.Rank]: t2,
      [ApiWaveType.Chat]: t3
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const components = t4;
  return components[waveType];
}